function showRecentlyViewedSection() {
  const viewedProducts = JSON.parse(localStorage.getItem('viewed_products')) || [];

  if (viewedProducts.length === 0) return;

  document.querySelectorAll('.recently_view_title, .section_recently_view').forEach((el) => {
    el.style.display = 'block';
  });
  loadAjaxTemplate(viewedProducts);
}

function trackRecentlyViewedProduct(event) {
  const link = event.target.closest('a.duamade_recently_view');
  if (!link) return;

  const productHandle = link.dataset.handle;
  const viewedProducts = JSON.parse(localStorage.getItem('viewed_products')) || [];
  const index = viewedProducts.indexOf(productHandle);

  if (index !== -1) {
    viewedProducts.splice(index, 1);
  }

  if (productHandle) {
    viewedProducts.unshift(productHandle);
  }

  localStorage.setItem('viewed_products', JSON.stringify(viewedProducts));
}

function loadAjaxTemplate(viewedProducts) {
  const container = document.getElementById('recently-viewed');
  if (!container) return;

  fetch('/collections/all?view=ajax&products=' + viewedProducts.join(','))
    .then((response) => {
      if (!response.ok) throw new Error('Failed to load recently viewed products');
      return response.text();
    })
    .then((html) => {
      container.innerHTML = html;
      hideLastItem(container);

      if (typeof window.initProductCardScrollers === 'function') {
        window.initProductCardScrollers(container);
      }

      const mountSplide = () => {
        const root = container.closest('[data-splide-defer]') || container;
        if (typeof window.runSplideInits === 'function') {
          window.runSplideInits(root);
        }
      };

      if (typeof window.ensureSplide === 'function') {
        window.ensureSplide(mountSplide);
      } else {
        mountSplide();
      }
    })
    .catch(() => {});
}

function hideLastItem(container) {
  const items = container.children;
  if (items.length > 0) {
    items[items.length - 1].style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', showRecentlyViewedSection);
document.addEventListener('click', trackRecentlyViewedProduct);
